
/* eslint-disable max-len */
import React from "react"
import { useState, useContext, useRef, useEffect } from "react"
import { motion } from "framer-motion"
import GlobalContext from "../../../../components/Context/GloablContext";
import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick";
import CustomOverLay from "../../../../components/CustomOverLay";
import { useLazyGetAssociatedOrganizationsQuery } from "../../../../features/providerSlice";
import Emptyscreenwithouttitle from "../../../../components/Emptyscreenwithouttitle";
import { useSearchParams } from "react-router-dom";

export default function OrganizationTable({
    viewOrganizationDetails,edit,onEditButtonClick,confirmation,
    onAddButtonClick, associatedOrganizations,result,setSelectedSubdivisionName,
    handleNoOfRowsClick,
    isOpenLimit,
    setIsOpenLimit,
    isColumnSelect,
    fetchPageAndLimit,
    limit,
    handlePrevClick,
    handleNextClick,
    totalPageNumber,
    setLimit,
    handleDeleteAssociatedOrganization,
    isMonitor,
    setShowPatientList,
    setOrgDetails,
    setisOpen,
    setisOpensub

}){
    const [searchParams, setSearchParams] = useSearchParams({})
    const [hoverProperties,setHoverProperties] = useState({
        'hover':'',
        'hover_index':'',
        'index_to_display_modal':''
    })
    const limitArr = [15, 30, 50, 100];
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);

    useOnClickOutside(ref, () => {
        setIsOpenLimit(false);
    });

    const {isSideBar} = useContext(GlobalContext);

    const handlePatientView = () =>{
        setSelectedSubdivisionName([])        
        let params = Object.fromEntries(searchParams);
        params['view'] = 'patient-list'
        setSearchParams({ ...params})
        
    }
   
    return(
        <>
           
            <div className='overflow-auto  scrollBar-hidden mt-3.5'>
                {result.status === 'pending' ||associatedOrganizations===undefined
                    ? <CustomOverLay Active text="Loading Organization Details..." classKey={`  h-[100px] left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'organizationoverlay'}`} />
                    : 
                    (associatedOrganizations?.data?.length>0?<>
                        <table aria-label="Outside Table" className="w-full table-auto">
                            <thead>
                                <tr className="h-[38px] w-full bg-[#EDD7E1] min-w-[200px] rounded-sm">
                                    <th id="id" className="px-3 py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">ID
                                        </span>
                                    </th>
                                    <th id="id" className="px-3 py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Organization Name
                                        </span>
                                    </th>
                                    <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Sub Division Name
                                        </span>
                                    </th>
                                    <th id='action' className="px-3 py-2 rounded-tr-[2px] rounded-br-[2px] bg-[#EDD7E1] min-w-[200px] max-w-[245px] sticky right-0">
                                        <span className={`flex items-center justify-center pl-[65px] text-sm font-normal text-[#000000] lg:ml-[-70px] xl:ml-[-70px] 2xl:ml-[10px] xl:min-w-[350px]`}>Actions
                                        </span>
                                    </th>
                                    
                                   
                                </tr>
                            </thead>
                            <tbody>
                                {associatedOrganizations?.data?.map((item,index) => (
                                    <tr key={index} className="h-[45px] table-tr">
                                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{item.organization_id}</td>
                                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{item.organization_name}</td>
                                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{item.subdivision_name}</td>    
                                        <td className={`px-8 py-2 text-sm text-end font-normal sticky  right-0 bg-[#F7F7F7] max-w-[245px] text-[#031624] rounded-tr-[2px] rounded-br-[2px] min-w-[50px]`}>  
                                            {isMonitor!==undefined?<div className="flex justify-between bg-[#d3cece08] lg:justify-between xl:justify-evenly"> 
                                                <div onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'add',hover_index:index}))}} 
                                                    onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}} className="px-1 2xl:min-w-[170px]">
                                              
                                                    {((hoverProperties.hover === 'add' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation))?<>
                                                        <motion.div
                                                            initial={{ opacity: 1, x: 0,y:0 }}
                                                            animate={{ opacity: 1, x: -58 ,y:0}}
                                                            transition={{ delay: 0.3, duration: 0.5 }}
                                                            exit={{ opacity: 0.5 ,x:0,y:0}}
                                                            className=''
                                                        >
                                                            <button 
                                                                // onClick={()=>{setShowPatientList(true),setOrgDetails(item)}}  
                                                                onClick={()=>{handlePatientView(),setOrgDetails(item),setSelectedSubdivisionName([])}}

                                                            > 
                                                                <img src="/images/addpinkplus.svg" alt="img" className="mx-auto w-5 mr-3" /></button>
                                                        </motion.div>
                                              
                                                    </>:<button 
                                                        // onClick={()=>{setShowPatientList(true),setOrgDetails(item)}}
                                                        onClick={()=>{handlePatientView(),setOrgDetails(item),setSelectedSubdivisionName([])}}

                                                        id={item.subdivision_name} 
                                                    > 
                                                        <img src="/images/addpinkplus.svg" alt="img" className="mx-auto w-5 mr-3" /></button>}
                                              
                                                    {((hoverProperties.hover === 'add' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation)) &&
                                                    <motion.div
                                                        initial={{ opacity: 0, x: 0,y:0 }}
                                                        animate={{ opacity: 1, x: 0 ,y:0}}
                                                        transition={{ delay: 0.5, duration: 0.5 }}
                                                        exit={{ opacity: 0.5 ,x:0,y:0}}
                                                        className=''
                                                    >
                                                  
                                                        <div className='relative ml-2 cursor-pointer mt-[-25px]' 
                                                            // onClick={()=>{setShowPatientList(true),setOrgDetails(item),setSearchParams({'tab':'patient-list'})}} 
                                                            onClick={()=>{handlePatientView(),
                                                            setOrgDetails(item),
                                                            setSelectedSubdivisionName([]);
                                                            }}

                                                        >
                                                  
                                                            <p className="font-normal" style={{"font-size":"12px"}}>Add Patient</p>
                                              
                                                        </div>
                                                    </motion.div>
                                          
                                                    }
                                              
                                                </div>
                                                <div onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'modify',hover_index:index}))}} 
                                                    onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}} className="lg:px-1 xl:px-8 2xl:min-w-[165px]">
                                       
                                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation))?<>
                                                        <motion.div
                                                            initial={{ opacity: 1, x: 0,y:0 }}
                                                            animate={{ opacity: 1, x: -40 ,y:0}}
                                                            transition={{ delay: 0.2, duration: 0.5 }}
                                                            exit={{ opacity: 0,x:0,transition: { duration: 0.5 ,delay:0.9} }}
                                                            className=''
                                                        >
                                                            <button 
                                                                onClick={()=>{setisOpen(false),setisOpensub(false),handleDeleteAssociatedOrganization(item,index)}}  
                                                            > 
                                                                <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>
                                                        </motion.div>
                                       
                                                    </>:<button 
                                                        onClick={()=>{setisOpen(false),setisOpensub(false),handleDeleteAssociatedOrganization(item,index)}} 
                                                        id={index + 'edit'} 
                                                    > 
                                                        <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>}
                                       
                                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation)) &&
                                                    <motion.div
                                                        initial={{ opacity: 0, x: 0,y:0 }}
                                                        animate={{ opacity: 1, x: 0 ,y:0}}
                                                        transition={{ delay: 0.4, duration: 0.5 }}
                                                        exit={{ opacity: 0,x:0,transition: { duration: 0.5 ,delay:0.9} }}
                                                        className=''
                                                    >
                                           
                                                        <div className='relative ml-4 cursor-pointer mt-[-25px]' onClick={()=>{setisOpen(false),setisOpensub(false),handleDeleteAssociatedOrganization(item,index)}} >
                                           
                                                            <p className=" ml-10  font-normal " style={{"font-size":"12px"}}>Remove</p>
                                       
                                                        </div>
                                                    </motion.div>
                                   
                                                    }
                                       
                                                </div>         
                                               
                                            
                                              
                                                        
                                                
                                            </div> :<div className="flex justify-center bg-[#d3cece08]" style={{'justify-content':'space-evenly'}}> 
                                                <div onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'add',hover_index:index}))}} 
                                                    onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}} className="lg:px-1  xl:px-8 2xl:min-w-[170px] ">
                                              
                                                    {((hoverProperties.hover === 'add' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation))?<>
                                                        <motion.div
                                                            initial={{ opacity: 1, x: 0,y:0 }}
                                                            animate={{ opacity: 1, x: -58 ,y:0}}
                                                            transition={{ delay: 0.3, duration: 0.5 }}
                                                            exit={{ opacity: 0.5 ,x:0,y:0}}
                                                            className=''
                                                        >
                                                            <button 
                                                                onClick={()=>{handlePatientView(),setOrgDetails(item)}}
                                                            > 
                                                                <img src="/images/addpinkplus.svg" alt="img" className="mx-auto w-5 mr-3" /></button>
                                                        </motion.div>
                                              
                                                    </>:<button 
                                                        onClick={()=>{handlePatientView(),setOrgDetails(item)}}
                                                        id={index + 'addpatient'} 
                                                    > 
                                                        <img src="/images/addpinkplus.svg" alt="img" className="mx-auto w-5 mr-3" /></button>}
                                              
                                                    {((hoverProperties.hover === 'add' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation)) &&
                                                    <motion.div
                                                        initial={{ opacity: 0, x: 0,y:0 }}
                                                        animate={{ opacity: 1, x: 0 ,y:0}}
                                                        transition={{ delay: 0.5, duration: 0.5 }}
                                                        exit={{ opacity: 0.5 ,x:0,y:0}}
                                                        className=''
                                                    >
                                                  
                                                        <div className='relative ml-2 cursor-pointer mt-[-25px]' onClick={()=>{handlePatientView(),setOrgDetails(item)}} >
                                                  
                                                            <p className="font-normal" style={{"font-size":"12px"}}>Add Patient</p>
                                              
                                                        </div>
                                                    </motion.div>
                                          
                                                    }
                                              
                                                </div>
                                              
                                                <div onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'modify',hover_index:index}))}} 
                                                    onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}} className="lg:px-1 xl:px-8 2xl:min-w-[170px]">
                                       
                                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation))?<>
                                                        <motion.div
                                                            initial={{ opacity: 1, x: 0,y:0 }}
                                                            animate={{ opacity: 1, x: -40 ,y:0}}
                                                            transition={{ delay: 0.2, duration: 0.5 }}
                                                            exit={{ opacity: 0,x:0,transition: { duration: 0.5 ,delay:0.9} }}
                                                            className=''
                                                        >
                                                            <button 
                                                                onClick={()=>{setisOpen(false),setisOpensub(false),handleDeleteAssociatedOrganization(item,index)}}  
                                                            > 
                                                                <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>
                                                        </motion.div>
                                       
                                                    </>:<button 
                                                        onClick={()=>{setisOpen(false),setisOpensub(false),handleDeleteAssociatedOrganization(item,index)}} 
                                                        id={index + 'edit'} 
                                                    > 
                                                        <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>}
                                       
                                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation)) &&
                                                    <motion.div
                                                        initial={{ opacity: 0, x: 0,y:0 }}
                                                        animate={{ opacity: 1, x: 0 ,y:0}}
                                                        transition={{ delay: 0.4, duration: 0.5 }}
                                                        exit={{ opacity: 0,x:0,transition: { duration: 0.5 ,delay:0.9} }}
                                                        className=''
                                                    >
                                           
                                                        <div className='relative ml-4 cursor-pointer mt-[-25px]' onClick={()=>{setisOpen(false),setisOpensub(false),handleDeleteAssociatedOrganization(item,index)}} >
                                           
                                                            <p className=" ml-10  font-normal " style={{"font-size":"12px"}}>Remove</p>
                                       
                                                        </div>
                                                    </motion.div>
                                   
                                                    }
                                       
                                                </div>         
                                              
                                            
                                            </div> }
                                            
                                        </td>  
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    
                        {associatedOrganizations && associatedOrganizations?.total_count>15 && 
                        <div className="w-[100%] px-2.5 pt-0 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]">
                                Total Number of Records: {associatedOrganizations?.total_count}
                            </p>
                            <div className="flex items-center">
                                <div className={`${isColumnSelect ? 'pl-1' : 'relative pl-1'}`}>
                                    <button
                                        ref={buttonRef}
                                        onClick={() => setIsOpenLimit(!isOpenLimit)}
                                        type="button"
                                        className="text-sm font-semibold text-[#687182] flex items-center"
                                    >
                                        <p>Rows per page: {fetchPageAndLimit().get("limit")}</p>
                                        <span className="pl-0.5">
                                            <img
                                                src="/images/down.svg"
                                                className={`${isOpenLimit ? "transform rotate-180" : ""}`}
                                                alt="icon"
                                                onClick={() => setIsOpenLimit(!isOpenLimit)}
                                            />
                                        </span>
                                    </button>
                                    <ul
                                        className={`absolute top-[-140px] left-[100px] pl-1.5 py-1.5 pr-0.5 z-[9999] bg-white border border-white h-fit rounded-sm shadow-xl ${isOpenLimit ? "" : "hidden"}`}
                                        ref={dropdownRef}
                                    >
                                        <li>
                                            <ul className="max-h-[110px] overflow-auto pr-2 bg-white scrollbar_gray_thin ">
                                                {limitArr.map((item, index) => (
                                                    <li key={index}>
                                                        <h1
                                                            onClick={() => {
                                                                setLimit(item);
                                                                setIsOpenLimit(false);
                                                                handleNoOfRowsClick(item);
                                                            }}
                                                            className={`text-base font-normal cursor-pointer ${
                                                                item === parseInt(limit) ? "text-[#008586]" : "text-[#00000]"
                                                            } mb-[16px]`}
                                                        >
                                                            {item}
                                                        </h1>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex items-center ml-5">
                                    <button
                                        disabled={parseInt(fetchPageAndLimit().get("page_number")) === 1}
                                        onClick={handlePrevClick}
                                        className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                    >
                                        <img src="/images/left.svg" alt="icon" />
                                    </button>
                                    <p className="text-sm font-semibold text-[#687182] mx-2.5">
                                        <span className="text-[#171C26]">{fetchPageAndLimit().get("page_number")}</span>/{totalPageNumber}
                                    </p>
                                    <button
                                        disabled={parseInt(fetchPageAndLimit().get("page_number")) === totalPageNumber}
                                        onClick={handleNextClick}
                                        className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                    >
                                        <img src="/images/right.svg" alt="icon" />
                                    </button>
                                </div>
                            </div>
                        </div>}
                    </>:<Emptyscreenwithouttitle   FirstPTag={"No organizations linked yet"}  />)}
            </div>
        </>
    )
}